//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Logo',
  props: {
    title: {
      type: String,
      default: '智慧水务',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
};